var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.235,
    height: 32,
    viewBox: "0 0 58.235 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-graphic-orange",
    transform: "translate(-1653.866 -299.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contour_20",
    "data-name": "contour 20",
    d: "M1654.822,327.844a4.657,4.657,0,0,1,3.584-2.479,28.829,28.829,0,0,1,4.537-.134,17.806,17.806,0,0,0,15.369-9.922c.773-1.621,1.316-3.395,2.493-4.751a6.463,6.463,0,0,1,6.008-2.059c1.739.343,3.291,1.4,5.05,1.625,3.476.432,6.373-2.414,8.954-4.783s6.368-4.556,9.377-2.762",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.461
  }), /*#__PURE__*/React.createElement("circle", {
    id: "elipse_15",
    "data-name": "elipse 15",
    cx: 2.27,
    cy: 2.27,
    r: 2.27,
    transform: "translate(1707.561 299.651)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.ce24f70440c284a8b8fceb0c4a27dae1.svg";
export { ForwardRef as ReactComponent };